import { TYPE_DMA, TYPE_RADIOMETRO } from "../components/Geofence/constant";

//validate advertiser
const NAME_ADVERTISER_REQUIRED = "Advertiser name is required";
const ADVERTISER_MULTI_MARKET_REQUIRED = "Multi-market selection is required";
const NAME_ADVERTISER_LENGTH_REQUIRED = "Adveriser has maximum 50 characters";
const NAME_ADVERTISER_DUPLICATED = "Advertiser name already exists"
const FOLDER_REQUIRED = "Please select a folder"
const NAME_ADVERTISER_EXISTED = "Advertiser name is existed in this folder"
const NAME_ADVERTISER_INVALID = "Invalid name. Advertiser name should not contain " + '\\' + " and " + '"' + " characters"
//campaign
const NAME_CAMPAIGN_REQUIRED = "Campaign name is required";
const NAME_CAMPAIGN_LENGTH_REQUIRED = "Campaign has maximum 100 characters";
const NAME_CAMPAIGN_DUPLICATED = "Duplicate campaign name";
const NAME_CAMPAIGN_EXISTED = "Campaign name is existed in this folder";
const NAME_CAMPAIGN_INVALID = "Invalid name. Campaign name should not contain " + '\\' + " and " + '"' + " characters";
export const NAME_DATETIME_REQUIRED = "Campaign date range is required";
export const ADVERTISER_REQUIRED = "Please select an advertiser";
export const CUSTOM_TIMESPAN_INVALID = "Invalid custom timespan";
export const MAXIMUM_DURATION_DAYS_DEFAULT = 365;
export const LIST_NAME_CAMPAIGN_ERROR = [
    NAME_CAMPAIGN_REQUIRED,
    NAME_CAMPAIGN_INVALID,
    NAME_CAMPAIGN_DUPLICATED,
    NAME_CAMPAIGN_EXISTED,
    NAME_CAMPAIGN_LENGTH_REQUIRED
]
const STATION_MARKET_REQUIRED = "Select at least one (1) market and one (1) station to continue";
const ADS_SEARCH_REQUIRED = "Select from Pre-Recorded Spots, Live Reads or Watchlists to continue";

export const FIND_ADS_CAMPAIGN_ERROR = {
    STATION_MARKET_REQUIRED,
    ADS_SEARCH_REQUIRED
}

//folder
const FOLDER_NAME_LENGTH_REQUIRED = "Folder has maximum 50 characters";
const FOLDER_NAME_DUPLICATED = "Duplicate folder name";
const FOLDER_NAME_REQUIRED = "Folder name is required!";
const FOLDER_NAME_INVALID = "Invalid folder name. Folder name should not contain " + '\\' + " and " + '"' + " characters";

//type of toast
export const SUCCESS = "Success";
export const FAILED = "Failed";
export const WARNING = "Warning";
export const INFO = 'Info';
export const ERROR = 'Error';
export const NOTE = 'Note';

// role id
export const ATTRIBUTE_ADMIN = "bd6458ec-d240-4eae-bdc1-d22740c6bd33";
export const ATTRIBUTE_MANAGER = "39f8ba2b-1e48-440c-9e8e-874865bfec08";
export const ATTRIBUTE_EDITOR = "94e0ed56-0b23-4517-bcae-96d44689fd20";
export const ATTRIBUTE_ALL_ACCESS = '6505c553-4f08-4c61-9862-d6d102946104';
export const ATTRIBUTE_ROLES = [ ATTRIBUTE_ALL_ACCESS, ATTRIBUTE_ADMIN, ATTRIBUTE_MANAGER, ATTRIBUTE_EDITOR ];
export const DISCOVERY_EDITOR = "3577dfc6-f441-41f9-8dab-ef9079530450";
export const CUSTOMER_SERVICE = "3459c3de-493f-443a-8ad0-ddb9f3f6c76d";

//CHART ID
export const GA_CHART_ID = 1;
export const ADVISIT_BY_DAY_OF_WEEK_CHART_ID = 2;
export const AD_PERFORMANCE_CHART_ID = 3;
export const DAYPART_COMPILATION_CHART_ID = 4;
export const STATION_CHART_ID = 8;
export const ADTYPE_CHART_ID = 7;
export const CREATIVE_CHART_ID = 9;
export const ADVISIT_CHART_ID = 9;
export const GEO_CHART_ID = 10;
export const TRAFFIC_CHANNEL_CHART_ID = 11;
export const KEYWORD_CHART_ID = 12;
export const DEVICE_CATEGORY_CHART_ID = 13;
export const PAGE_PATH_CHART_ID = 14;

export const WEB_TAB = 'webanalytics';
export const DAYPART_TAB = 'daypartanalytics';
export const PLACEMENT_TAB = 'placementanalytics';
export const CREATIVE_TAB = 'creativeanalytics';
export const LOCATION_TAB = 'geoanalytics';
export const CHANNELS_TAB = 'channelanalytics';
export const DEVICE_CATEGORY_TAB = 'devicecategoryanalytics';
export const PAGE_PATH_TAB = 'pagepathanalytics';
export const REPORTS_TAB = 'reports';

export const newAdUsersMetricKey = 'newAdUsersMetric';
export const newUserSessionsKey = 'newUserSessions';
export const newAdUsersKey = "newAdUsers";
export const newAdUsersPerAdsKey = "newAdUsersPerAds";
export const avgAdCostKey = 'avgAdCost';

export const DEFAULT_CAMPAIGN_TAB = WEB_TAB;
export const ALL_CHARTS_ID = [
    GA_CHART_ID,
    ADVISIT_BY_DAY_OF_WEEK_CHART_ID,
    AD_PERFORMANCE_CHART_ID,
    DAYPART_COMPILATION_CHART_ID,
    STATION_CHART_ID,
    ADTYPE_CHART_ID,
    ADVISIT_CHART_ID,
    GEO_CHART_ID,
    TRAFFIC_CHANNEL_CHART_ID,
    KEYWORD_CHART_ID,
    DEVICE_CATEGORY_CHART_ID,
    PAGE_PATH_CHART_ID,
];

export const CHARTS_IN_TAB = {
    //NOTE: GA_CHART must load first in order to get summary data for now, so it's excluded in webanalytics
    [WEB_TAB]: [GA_CHART_ID, ADVISIT_BY_DAY_OF_WEEK_CHART_ID, AD_PERFORMANCE_CHART_ID],
    [DAYPART_TAB]: [DAYPART_COMPILATION_CHART_ID],
    [PLACEMENT_TAB]: [ADTYPE_CHART_ID, STATION_CHART_ID],
    [CREATIVE_TAB]: [ADVISIT_CHART_ID],
    [LOCATION_TAB]: [GEO_CHART_ID],
    [CHANNELS_TAB]: [TRAFFIC_CHANNEL_CHART_ID, KEYWORD_CHART_ID],
    [DEVICE_CATEGORY_TAB]: [DEVICE_CATEGORY_CHART_ID],
    [PAGE_PATH_TAB]: [PAGE_PATH_CHART_ID],
};

export const DEFAULT_CAMPAIGN_CHART_IDS = Object.values(CHARTS_IN_TAB).reduce((acc, list) => {
    acc.push(...list);
    return acc;
}, []);

//CHART TO GET REASSIGN MENTION
export const REASSIGN_GET_ID = 9;

//Tab in create/edit advertiser
export const ADVERTISER_DETAIL_TAB = "detail";
export const ADVERTISER_INVITE_TAB = "invite";

//PROPERTIES ELEMENT FOR CHARTS
export const FIRST_VALUE = "firstValue";
export const SECOND_VALUE = "secondValue";
export const DATE_CHANGE_VALUE = "change"
export const TIME = "time";

export const VISITS = {
    label: "Total Visits",
    shortLabel: "Visits",
    value: "visitDataForChart"
};

export const USERS = {
    label: "Total Users",
    shortLabel: "Users",
    value: "userDataForChart"
};

export const HOUR = {
    label: "By Hour",
    value: "hour"
};

export const DATE = {
    label: "By Date",
    value: "date"
};

export const FIRST_COLOR_CHART = "#00BCD4";
export const SECOND_COLOR_CHART = "#3F51B5";

export const LIMIT_ROWS_PER_PAGE = 14;

//Tab in create/edit campaign
export const CAMPAIGN_DETAIL_TAB = "detail";
export const CAMPAIGN_FIND_ADS_TAB = "find-ads";
export const CAMPAIGN_GEOFENCING_TAB = "filters";
export const CAMPAIGN_SELECT_STATIONS_TAB = "select-stations";

//the number creative name in A4 page
export const MAX_LENGTH_CREATIVE_DATA = 55;
export const MIN_LENGTH_CREATIVE_DATA = 14;
export const AVERAGE_CREATIVE_DATA = 45;
export const MAX_LENGTH_FIRST_PAGE_PDF = 29;
export const MAX_LENGTH_FIRST_PAGE_PDF_OF_GEO_FENCE = 11;
export const MAX_LENGTH_LOCATION_DATA = 26;
export const SINGLE_PAGE_WEB_ANALYTICS_DATA = 26;
export const MIN_LENGTH_WEB_ANALYTICS_DATA = 9;
export const MIN_LENGTH_CUSTOM_WEB_ANALYTICS_TABLE_ROWS = 12;
export const CHART_LENGTH_WEB_ANALYTICS_DATA = 15;
export const MIN_LENGTH_PLACEMENT_AD_TYPE = 17;
export const MIN_LENGTH_PLACEMENT_STATION = 11;
export const MIN_LENGTH_PLACEMENT = 7;
export const MIN_LENGTH_TRAFFIC_CHANNEL_DATA = 12;
export const MIN_LENGTH_PAGE_PATH_DATA = 14;
export const MIN_LENGTH_DAYPART_DATA = 14;
export const COMMON_NUMBER_TABLE_ROWS_TO_TRUNCATE = 2;
export const MAX_NUMBER_TABLE_ROWS_TO_TRUNCATE = 3;

export const DIAL_CODE_US = "1"

export const CONNECT_GA_STATUS = {
    PENDING: 0,
    CONNECTED: 1,
    DISCONNECTED: 2
}

export const CONNECT_PIXEL_STATUS = {
    NOT_CONNECTED: 0,
    CONNECTED: 1,
}

export const VISUAL_STATUS = {
    PENDING: 0,
    SUCCESS: 1,
    ERROR: 2,
    WARNING: 3,
    DORMANT: 4,
};

export const CONNECTION_SOURCE = {
    GA: 'googleAnalytic',
    WEB_UPLOAD: 'webUploader',
    PIXEL: 'pixel',
    GBQ: 'gbq',
}

export const MINIMUM_RECENT_VISITS = 10;
export const GA_MINIMUM_RECENT_HOURS = 48;
export const GA_MAXIMUM_RECENT_DAYS = 14;
export const WEB_LOGS_MINIMUM_RECENT_DAYS = 7;
export const WEB_LOGS_MAXIMUM_RECENT_DAYS = 14;
export const WEB_LOG_ACTIVE_RECENT_HOURS = 3;

//status engine of visual refresh data
export const STATUS_ENGINE_ERROR = -1;
export const STATUS_ENGINE_PROCESSING = 1;
export const STATUS_ENGINE_PREPARING = 0;
export const STATUS_ENGINE_COMPLETE = 5;
export const JOB_STATUS = {
    [STATUS_ENGINE_ERROR]: {
        status_engine: -1,
        type: "failed",
        statusDescription: "Failed"
    },
    [STATUS_ENGINE_PROCESSING]: {
        status_engine: 1,
        type: "processing",
        statusDescription: "Processing..."
    },
    [STATUS_ENGINE_PREPARING]: {
        status_engine: 0,
        type: "preparing",
        statusDescription: "Preparing..."
    },
    [STATUS_ENGINE_COMPLETE]: {
        status_engine: 5,
        type: 'complete',
        statusDescription: 'Complete!'
    }
}

export const AD_TYPE_ID = {
    'Live Reads': 1,
    'Pre-recorded Spots': 2,
    'Watchlists (Mentions)': 3
}

export const SUMMARY_DATA_NUM_WEEKS = 4;

export const SORT_BY_VISIT_PER_AD = { sortKey: 'visitOfAds', sortType: 'desc' };
export const SORT_BY_NEW_AD_USERS_PER_ADS = { sortKey: 'newAdUsersOfAds', sortType: 'desc' }
export const SORT_BY_AD_VISIT = { sortKey: 'adVisits', sortType: 'desc' };

export const mapCommonSortKeyToText = {
    visitOfAds: 'Ad Visits/Ads',
    visit: 'Total Visits',
    totalVisits: 'Total Visits',
    adVisit: 'Ad Visits',
    ads: 'Ads',
    avgAdCost: 'Avg. Ad Cost',
    visitsPerAd: 'Ad Visits/Ads',
    creativeName: 'Creative Name',
    adType: 'Ad Type',
    duration: 'Duration',
    name: 'Location',
    visits: 'Ad Visits',
    visitsOfAds: 'Ad Visits/Ads',
    trafficType: 'Traffic Channel',
    adVisits: 'Ad Visits',
    keywordValue: 'Keyword',
    newAdUsers: 'New Ad Users',
    newUsers: 'New Users',
    newAdUsersPerAds: "New Ad Users/Ads",
    newAdUsersOfAds: 'New Ad Users/Ads',
    pagePathType: 'Page Path',
    deviceType: 'Device Category',
}

export const mapAdTypeSortKeyToText = {
    ...mapCommonSortKeyToText,
    title: 'Ad Type',
}

export const mapStationSortKeyToText = {
    ...mapCommonSortKeyToText,
    title: 'Station',
}

export const mapKeywordSortKeyToText = {
    ...mapCommonSortKeyToText,
    visits: 'Visits',
}

export const SHOW_TOAST_ACTIONS = {
    SUMMARY_DRILL_DOWN: "Show toast summary drill down"
}

// status for mention in summary drill down
export const INCLUDE = 1;
export const EXCLUDE = 2;
export const REASSIGN = 3;
export const REASSIGNED = 2;
export const BETA_FEATURES = [];

//status for loading geo child status
export const GEO_CHILD_LOAD_STT = {
    INITIAL: "initial",
    LOADING: "loading",
    LOADED: "loaded",
    FAIL: "fail"
}

//TODO remove this
export const LIST_CHART = {
    1: {
        chartTitle: ""
    },
    2: {
        chartTitle: "Visits by Day of Week"
    },
    3: {
        chartTitle: ""
    },
    4: {
        chartTitle: ""
    },
    5: {
        chartTitle: ""
    },
    6: {
        chartTitle: ""
    },
    7: {
        chartTitle: ""
    },
    8: {
        chartTitle: ""
    },
    9: {
        chartTitle: ""
    },
    10: {
        chartTitle: "Ad Visits by Location"
    }
}

//user permission
export const OWNER = 'owner';
export const MANAGER = 'manager';
export const EDITOR = 'editor';
export const VIEWER = 'viewer';
export const INHERIT = 'inherit';

//global dialog
export const DIALOG_SHARE_ADVERTISER = 'shareAdvertiser';
export const DIALOG_SHARE_CAMPAIGN = 'shareCampaign';
export const DIALOG_ASSIGN_OWNER = 'assignOwner';

// advertiser/campaign permission
export const CAMPAIGN_USER_PERMISSION = 'campaignUser';
export const EDIT_PERMISSION = 'editPermission';
export const SHARE_PERMISSION = 'sharePermission';
export const PRIORITY_PERMISSION = [ CAMPAIGN_USER_PERMISSION, SHARE_PERMISSION, EDIT_PERMISSION ];

export const DEFAULT_ADVERTISER_LOGO_EXPIRE_TIME = 3600; //seconds
export const DEFAULT_ORG_LOGO_EXPIRE_TIME = 3600; //seconds

export const CAMPAIGN_TAB = [
    WEB_TAB,
    DAYPART_TAB,
    PLACEMENT_TAB,
    CREATIVE_TAB,
    LOCATION_TAB,
    CHANNELS_TAB,
    DEVICE_CATEGORY_TAB,
    PAGE_PATH_TAB,
    REPORTS_TAB
];

export const VERITONE_DEFAULT_LOGO = 'https://static.veritone.com/logo/veritone-logo.png';

export const INVALID_IMAGE = 'Invalid image';

//findAds type
export const PRERECORDED = 'preRecorded';
export const LIVEREAD = 'liveRead';
export const WATCHLIST = 'watchList';

//advertiser route
export const ADVERTISER_STEP_ROUTE = 'steps';
export const ADVERTISER_DASHBOARD_ROUTES = [ADVERTISER_STEP_ROUTE]; //TODO: add more route

// tracking data source type
export const TRACKING_SOURCE_TYPE = {
    GOOGLE_ANALYTICS: 1,
    GA4: 2,
    ADOBE: 4,
}

export const TRACKING_SOURCE_NAME = {
    GA4: 'ga4',
    BIG_QUERY: 'big_query',
    PIXEL: 'pixel',
    WEB_UPLOAD: 'web_logs',
    ADOBE: 'adobe'
}

export const ADVERTISER_SOURCE_TYPE = {
    CUSTOM: 0,
    GA4: 2,
    WEB_UPLOAD: 3,
    GBQ: 4,
    PIXEL: 5,
};

export const ENABLED = 'enabled';
export const NON_REGIONAL = 'Non-Regional';
export const ATTRIBUTE_APPLICATION_ID = '2d6e9991-e551-458c-9e9c-0c70aeaea456';

export const loadingStatus = {
    idle: 'idle',
    loading: 'loading',
    success: 'success',
    error: 'error',
}

export const CREATIVE_TYPE_OPTIONS = {
    visitOfads: {
      value: 'visitOfads',
      label: 'Ad Visits/Ads'
    },
    avgAdCost: {
      value: 'avgAdCost',
      label: 'Avg. Ad Cost'
    },
    visits: {
      value: 'visits',
      label: 'Ad Visits'
    },
    adUser: {
      value: 'adUser',
      label: 'Ad Users'
    },
    creative_name: {
      value: 'creative_name',
      label: 'By Creative',
    },
    creative_duration: {
      value: 'creative_duration',
      label: 'By Duration',
    },
    [newAdUsersKey]: {
      value: newAdUsersKey,
      label: 'New Ad Users',
    },
}

export const LIMIT_CHART_DATA = 5;

export default {
    DEFAULT_ORG_LOGO_EXPIRE_TIME,
    NAME_ADVERTISER_DUPLICATED,
    NAME_ADVERTISER_REQUIRED,
    ADVERTISER_MULTI_MARKET_REQUIRED,
    NAME_ADVERTISER_LENGTH_REQUIRED,
    FOLDER_REQUIRED,
    NAME_ADVERTISER_INVALID,
    ADVERTISER_REQUIRED,
    NAME_CAMPAIGN_DUPLICATED,
    NAME_CAMPAIGN_EXISTED,
    NAME_CAMPAIGN_INVALID,
    NAME_CAMPAIGN_LENGTH_REQUIRED,
    NAME_CAMPAIGN_REQUIRED,
    NAME_DATETIME_REQUIRED,
    FOLDER_NAME_DUPLICATED,
    FOLDER_NAME_LENGTH_REQUIRED,
    FOLDER_NAME_REQUIRED,
    FOLDER_NAME_INVALID,
    SUCCESS,
    FAILED,
    WARNING,
    NAME_ADVERTISER_EXISTED,
    ATTRIBUTE_ADMIN,
    ATTRIBUTE_MANAGER,
    ATTRIBUTE_EDITOR,
    ATTRIBUTE_ALL_ACCESS,
    CUSTOMER_SERVICE,
    STATION_CHART_ID,
    ADTYPE_CHART_ID,
    OWNER,
    MANAGER,
    EDITOR,
    VIEWER,
    INHERIT,
    CAMPAIGN_TAB,
    VERITONE_DEFAULT_LOGO,
    INVALID_IMAGE,
    TRACKING_SOURCE_TYPE,
    MAXIMUM_DURATION_DAYS_DEFAULT
}

export const partiableWebTableHeaders = {
  [newAdUsersKey]: [
    { title: 'Total Visits', key: 'visit' },
    { title: 'New Ad Users', key: 'newAdUsers' },
    { title: 'Ads', key: 'ads' },
    { title: 'New Ad Users/Ads', key: 'newAdUsersPerAds' },
  ],
  default: [
    { title: 'Total Visits', key: 'visit' },
    { title: 'Ad Visits', key: 'adVisit' },
    { title: 'Ads', key: 'ads' },
    { title: 'Ad Visits/Ads', key: 'visitsPerAd' },
  ],
}

export const OTHER_TRAFFIC_CHANNEL_ID = 'c9f0f895fb98ab9159f51fd0297e236d';
export const CUT_OVER_DATE_VALUE = '2023-02-02 14:00:00.000 +0700';
export const UA_SUNSET_MESSAGE = 'Universal Analytics was sunset by Google as of July 1st, 2023. If not completed yet, add a GA4 connection to your Advertiser in the Manage Connections page to continue attribution reporting.';
export const UA_SUNSET_LABEL = 'NOTE';
export const NEW_AD_USERS_SUNSET_MESSAGE = 'After July 1st 2023, Google Analytics 4 does not provide data for this field.';
export const GA4_DAYPART_MESSAGE = 'With GA4, Daypart data does not currently contain location information. Data estimates are instead based on total web visits.';

export const ENGINE_MESSAGE = {
    [JOB_STATUS[STATUS_ENGINE_PREPARING].type]: {
      type: INFO,
      label: 'Waiting to Process'
    },
    [JOB_STATUS[STATUS_ENGINE_PROCESSING].type]: {
      type: INFO,
      label: 'Processing'
    },
    [JOB_STATUS[STATUS_ENGINE_ERROR].type]: {
      type: ERROR,
      label: 'Failed to process campaign.'
    },
    [JOB_STATUS[STATUS_ENGINE_COMPLETE].type]: {
      type: SUCCESS,
      label: 'Your campaign is active.'
    }
};

export const ATTRIBUTE_PIXEL_FEATURE_FLAG_KEY = 'attributePixelConnectionType';
export const GOOGLE_BIGQUERY_FEATURE_FLAG_KEY = 'googleBigQueryIngestion';
export const ADOBE_ANALYTICS_FEATURE_FLAG_KEY = 'adobeAnalyticsIngestion';
export const EMAIL_MAPPING_CONFIG_FEATURE_FLAG_KEY = 'emailLogIngestionSettings';
export const CAMPAIGN_TYPE_CONFIGURATION_FLAG_KEY = 'campaignTypeConfiguration';
export const ORG_SETTING_CONNECTION_CUSTOM_LABEL = 'advertiser_connection_label';
export const ORG_SETTING_CONNECTION_INVITATION_EMAILS = 'connection_invitation_emails';
export const ATTRIBUTE_CONNECTION_AGENT = 'attributeConnectionAgent';
export const ORG_SETTING_GLOSSARY_CONFIG = 'glossary_config';
export const PLAYOUT_INGESTION_VER2_FLAG_KEY = 'enablePlayoutIngestionVer2';

export const CAMPAIGN_SEARCH_INSTRUCTIONS_TYPES = [
  {
    name: 'Locate Pre-Recorded Spots',
    key: 'pre_recorded',
    subtitle: `Use this highly accurate method to search for any ads recorded within your organization's traffic logs.`,
    additionText: 'Add Additional Text to Pre-Recorded Spots Search',
    descriptiveText: `Please input the Advertiser Name or Event Name EXACTLY as it is labeled in your station's reconciled traffic logs. When in doubt, we recommend validating with your traffic team or requesting post logs for review.`,
  },
  {
    name: 'Track Live Mentions',
    key: 'live_read',
    subtitle: `Use keywords or phrases to phonetically search your media's transcription.`,
    additionText: 'Add Additional Text to Live Mentions Search',
    descriptiveText: 'Remember to utilize quotations when searching for any name, phrase or string longer than one word, such as "breaking news" versus news.',
  },
];

export const AVAILABLE_CONNECTION_TYPES = [
    {
      name: 'Veritone Attribute Pixel',
      value: TRACKING_SOURCE_NAME.PIXEL,
      featureFlagKey: ATTRIBUTE_PIXEL_FEATURE_FLAG_KEY
    },
    {
      name: 'Adobe Analytics',
      value: TRACKING_SOURCE_NAME.ADOBE,
      featureFlagKey: ADOBE_ANALYTICS_FEATURE_FLAG_KEY
    },
    {
      name: 'Google BigQuery (GBQ)',
      value: TRACKING_SOURCE_NAME.BIG_QUERY,
      featureFlagKey: GOOGLE_BIGQUERY_FEATURE_FLAG_KEY
    },
    {
      name: 'Google Analytics GA4',
      value: TRACKING_SOURCE_NAME.GA4
    },
    {
      name: 'Custom Data Load',
      value: TRACKING_SOURCE_NAME.WEB_UPLOAD

    }
  ];

export const ADVERTISER_CONNECTION_LABEL = 'advertiser_connection_label';

export const CONNECTION_NAME = {
    [TRACKING_SOURCE_NAME.PIXEL]: 'Attribute Pixel',
    [TRACKING_SOURCE_NAME.BIG_QUERY]: 'Google BigQuery (GBQ)',
    [TRACKING_SOURCE_NAME.GA4]: 'Google Analytics',
    [TRACKING_SOURCE_NAME.WEB_UPLOAD]: 'Custom Data Load',
    [TRACKING_SOURCE_NAME.ADOBE]: 'Adobe Analytics',
}

export const MEGAPHONE_CLASS_NAME = {
    [VISUAL_STATUS.SUCCESS]: 'successIconStatus',
    [VISUAL_STATUS.ERROR]: 'errorIconStatus',
    [VISUAL_STATUS.WARNING]: 'warningIconStatus',
    [VISUAL_STATUS.PENDING]: 'pendingIconStatus',
    [VISUAL_STATUS.DORMANT]: 'dormantIconStatus'
};

export const QBQ_BILLING_ACCOUNT_DESCRIPTION = `GBQ projects must have an enabled Billing Account in order to update the project’s expiration date, ensuring Veritone maintains active access to your advertiser's web traffic data. For assistance with enabling your Billing Account, use`;
export const GBQ_PROJECT_EXPIRATION_DESCRIPTION = `GBQ project’s expiration date must be updated to a status of Never to ensure Veritone maintains active access to your advertiser’s web traffic data. For assistance with updating project expiration, use`;

export const billingAccountStatus = {
    Enabled: 'Enabled',
    Disabled: 'Disabled',
  }

export const gbqProjectExpirationStatus = {
    Never: 'never',
    NeedsUpdate: 'needs update',
  }

export const ADOBE_SCOPE = [
  'openid',
  'AdobeID',
  'read_organizations',
  'additional_info.projectedProductContext',
  'additional_info.job_function'
];

export const GA_MAXIMUM_RECENT_HOURS = 96;
export const GBQ_MINIMUM_EXPIRATION_HOURS = 48;
export const GBQ_MAXIMUM_RECENT_HOURS = 72;
export const INACTIVE_THRESHOLD_DAYS = 14;

export const IHEART_ORG_ID = 14871;

export const hideAppBarPagesList = [
  '/campaign/:campaignId/edit',
  '/campaign/new',
  '/playout/browse',
  '/advertiser/:advertiserId/edit/:tab',
  '/advertiser/new',
  '/create_report/advertiser'
];

export const UNRATED_FIELDS = {
  [TYPE_DMA]: 'isInDMA',
  [TYPE_RADIOMETRO]: 'isInMetro'
};
